import styled from 'styled-components';

export const HeaderText = styled.p`
  color: #9f9f9f;
  font-size: 1rem;
  font-weight: bold;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const RowInputs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;

  > button {
    max-width: fit-content !important;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;

    > button {
      width: 100%;
      max-width: unset !important;
      margin: 0;
    }
  }
`;
